<div class="ddr-add-reminder-dialog">
  <div mat-dialog-title oneDialogTitle>
    <span i18n="@@input-dialog-example.title">Create reminder</span>
  </div>
  <div mat-dialog-content oneDialogContent class="import-dialog-content">
    <p i18n="@@input-dialog-example.patient-name">Feedback due date: <strong>{{feedbackDueDate}}</strong></p>
    <div class="reminder-date-section">
      <p>Set reminder date:</p>
      <mat-form-field appearance="outline" class="ddr-template-txt-box" oneFormField>
        <mat-label>Reminder date</mat-label>
        <input
        matInput
        [formControl]="reminderDate"
        [matDatepicker]="reminderDatepicker"
        [matDatepickerFilter]="reminderDateFilter"
        (focus)="reminderDatepicker.open()"
        (dateInput)="getReminderDate(reminderDatepicker.value)"
        data-test-id="basic-datepicker-component.input"
        />
        <mat-datepicker-toggle matSuffix [for]="reminderDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #reminderDatepicker [calendarHeaderComponent]="datepickerHeader" panelClass="one-datepicker"></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="reminder-message-section">
      <p>Add a reminder message:</p>
      <div class="msg-attach-subject">
        <mat-form-field appearance="outline" oneFormField>
          <mat-label>Subject</mat-label>    
          <input matInput [formControl]="subjectName" type="text" (keyup)="onKeyupSubjectName($event)" (blur)="onBlurSubjectName($event)" min="5" max="250"/>
          <button mat-icon-button one-icon-button matSuffix (click)="subjectName.setValue('')" *ngIf="subjectName.value">
            <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <dl-rich-text-document [jsonTextItem]="reminderRTEDoc" (jsonTextReturn)="setRTEText($event)" ></dl-rich-text-document>
      <div class="msg-attach-templete-apply">
        <mat-checkbox [(ngModel)]="addTempleteCheck" [disabled]="disabledApplyCheckbox" style="flex:1">Add this reminder message to your templates</mat-checkbox>
      </div>
    </div>
    <div class="reminder-consent-section">
      <p>How do you want the reminder to be sent?</p>
      <mat-radio-group
      [formControl]="reminderConsent"
      (change)="radioChange($event)"
      aria-labelledby="example-date-picker-group-label"
      class="example-date-picker-radio-group"
      >
        <mat-radio-button
        class="example-radio-button"
        i18n-aria-label="@@datepicker.radio-today-example"
        value="0"
        data-test-id="quick-datepicker-component.today"
        >The tool should automatically send the reminder to the customer
        </mat-radio-button>
        <mat-radio-button
        class="example-radio-button"
        i18n-aria-label="@@datepicker.radio-next-week-example"
        value="1"
        data-test-id="quick-datepicker-component.next-week"
        >I want to be notified so I can send the reminder manually
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div mat-dialog-actions oneDialogActions class="import-dialog-actions">
    <button one-secondary-button mat-stroked-button [mat-dialog-close]="true">Cancel</button>
    <button *ngIf="!isEditRow" color="primary" [disabled]="!subjectName.value || !reminderDate.value || reminderDate.invalid || !reminderRTEDoc  || reminderRTEDoc =='<p></p>'" [mat-dialog-close]="data" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="addReminder()">
      Add
    </button>
    <button *ngIf="isEditRow" color="primary" [disabled]="!subjectName.value || !reminderDate.value || reminderDate.invalid || !createReminderTxt || createReminderTxt=='<p></p>'" [mat-dialog-close]="data" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="updateReminder()">
      Update
    </button>
  </div>
</div>
  